var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4812 4.86084L3.4812 3.46191C3.4812 2.07122 4.60858 0.943848 5.99927 0.943848V0.943848C7.38996 0.943848 8.51733 2.07123 8.51733 3.46192V4.86084",
    stroke: "#01021D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7998 4.40039C10.6282 4.40048 11.2998 5.07202 11.2998 5.90039V11.1006C11.2995 11.9287 10.6279 12.6005 9.7998 12.6006H2.2002C1.37197 12.6006 0.700527 11.9287 0.700195 11.1006V5.90039C0.700196 5.07196 1.37177 4.40039 2.2002 4.40039H9.7998ZM5.99902 7.67676C5.53574 7.677 5.16027 8.05231 5.16016 8.51562C5.16016 8.97904 5.53567 9.35522 5.99902 9.35547C6.46259 9.35547 6.83887 8.97919 6.83887 8.51562C6.83875 8.05216 6.46252 7.67676 5.99902 7.67676Z",
    fill: "#01021D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffchain);
export default __webpack_public_path__ + "static/media/offchain.df8d32046baebad87f27c0720affd3bd.svg";
export { ForwardRef as ReactComponent };